import { Nullable } from '@Models';
import { FolderView } from '../../common/ArmyListView';

export class ArmyListEditView {
  name: string;
  folderId: Nullable<string>;
  folders: Array<FolderView>;
  max: number;
  isPrivate: boolean;
  notes: Nullable<string>;
  canSubmit: boolean;

  constructor(params: ArmyListEditViewParams) {
    this.name = params.name ?? '';
    this.folderId = params.folderId ?? null;
    this.folders = params.folders ?? new Array<FolderView>();
    this.max = params.max ?? 4500;
    this.isPrivate = params.isPrivate ?? false;
    this.notes = params.notes ?? null;
    this.canSubmit = params.canSubmit;
  }
}

export type ArmyListEditViewParams = {
  name: string;
  folderId: Nullable<string>;
  folders: Array<FolderView>;
  max: number;
  isPrivate: boolean;
  notes: Nullable<string>;
  canSubmit: boolean;
};
